import Slide, { SlideProps } from '@mui/material/Slide';
import { forwardRef } from 'react';

const ModalTransition = forwardRef(function Transition(props: SlideProps, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default ModalTransition;
